import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from '../../shared-service/base.service';
import { SharingPanelService } from '../../shared-service/sharing-panel-service';
import { MyTasksService } from '../../learner/my-tasks/my-tasks.service';
import { SharingPanelComponent } from '../sharing-panel/sharing-panel.component';
import { StringifyOptions } from 'querystring';
import { isAbsolute } from 'path';

declare var $: any;

@Component({
  selector: 'app-learning-card',
  templateUrl: './learning-card.component.html',
  styleUrls: ['./learning-card.component.css']
})
export class LearningCardComponent implements OnInit {

  @Input() LearningCard: {
    CourseID: any,
    ILTID: any,
    CourseImage: any,
    CourseRating: any,
    GamificationPoints: any,
    GamificationUserAchievedPoints: any,
    Progress: any,
    CourseName: any,
    CourseTypeName: any,
    LearningFlag: any,
    Topic: any,
    CreditHours: any,
    ExpiryDay: any,
    ExpiryYear: any,
    StartDay: any,
    StartYear: any,
    ChildNodeAction: any,
    Status: any,
    CourseType: any,
    MyUserProfiles: Array<any>,
    MyPeers: Array<any>,
    MappedSkills: Array<any>,
    AvgKpiImprovement: any,
    Coursekeywords: Array<any>,
  } = {
    CourseID: '',
    ILTID: '',
    CourseImage: '',
    CourseRating: '',
    GamificationPoints: '',
    GamificationUserAchievedPoints: '',
    Progress: '',
    CourseName: '',
    CourseTypeName: '',
    LearningFlag: '',
    Topic: '',
    CreditHours: '',
    ExpiryDay: '',
    ExpiryYear: '',
    StartDay: '',
    StartYear: '',
    ChildNodeAction: '',
    Status: '',
    CourseType: '',
    MyUserProfiles: [],
    MyPeers: [],
    MappedSkills: [],
    AvgKpiImprovement: '',
    Coursekeywords: [],
  };
  @Input() CardType: string = "";

  params: Object = {};
  isPlay: boolean = false;
  public Item: Array<Object> | any= [];
  private obj: object | any;
  public ItemDetail: Object | any = {};
  public currentUrl: string | any;
  enableActiveWall: boolean = false;

  constructor(public bs: BaseService, private router: Router, private route: ActivatedRoute, private sps: SharingPanelService, public myTasksService: MyTasksService) { }
  ngOnInit() {
    
    this.enableActiveWall = this.bs.getUserAttr("IsEnableActiveWall"); 
    console.log('this.Type:-' + this.CardType);
    this.isPlay = this.CardType == 'play' ? true : false;
    this.ItemDetail = this.LearningCard;
    $(".course").hover(function () {
      $(this).find(".progress-bar-main").css({ "display": "none" });
      //$(this).find(".icons .play").animate({bottom: "0"},0.1);
      $(this).find(".icons .select").animate({ bottom: "0" }, 0.1);
      $(this).find(".icons .share").animate({ bottom: "0" }, 0.1);
      $(this).find(".icons .report").animate({ bottom: "0" }, 0.1);
      $(this).find(".icons .add").animate({ bottom: "0" }, 0.1);
    });

    $(".course").mouseleave(function () {
      $(".progress-bar-main").css({ "display": "block" });
      //$(".icons .play").css({"bottom": "-100px"});
      $(".icons .select").css({ "bottom": "-100px" });
      $(".icons .share").css({ "bottom": "-100px" });
      $(".icons .report").css({ "bottom": "-100px" });
      $(".icons .add").css({ "bottom": "-100px" });
      $(".icons .play").css({ "display": "block" });
      $(".icons .add").css({ "display": "block" });
    });

    
    this.currentUrl = window.location.href;
  }

  flip(id:any) {
    $('#' + id).toggleClass('hover');
  }


  openLearningDetail(learning:any, flag:any, type:any) {    
    
    this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
    let params : any = {
      tab: '',
      id: learning.CourseID
    }
    if (type == 'P') {
      if (learning['CourseType'] == "T") {
        params['id'] = learning['ILTID'];
        this.bs.routerParam['ILT_DETAIL'] = params;
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), params);
      }
      else {
        this.router.navigate(['/learner/taskList/container/catalog-detail', { tab: '', id: learning['CourseID'] }], { relativeTo: this.route.parent });
      }
    }
    else if (this.isPlay) {
      if (learning['CourseType'] == 'T') {
        this.router.navigate(['/learner/taskList/container/catalog-ilt-detail', { tab: '', id: learning['ILTID'], cns: learning['CNS'] }], { relativeTo: this.route.parent });
      }
      else {
        this.router.navigate(['/learner/taskList/container/catalog-detail', { tab: '', id: learning['CourseID'] }], { relativeTo: this.route.parent });
      }
    } else {
      if (learning['CourseType'] == "T") {
        params['id'] = learning['ILTID'];
        this.bs.routerParam['ILT_DETAIL'] = params;
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), params);
      } else if (learning.CourseType == "E") {
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('extrnl_dtls'), params);
      } else {
        /*Navigate to course*/
        this.bs.isResumeClicked = flag;
        params['CourseLaunchId'] = '';
        params['IsNodeClick'] = false;
        // console.log(this.bs.getFullPath('crs_dtl'));
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), params);
      }
    }
  }

  routeTo(path: string, params: object) {
    this.router.navigate([path, params]).then((res) => {
      console.log(res);
    });
  }

  loadGamificationRule(id: string) {
    for (var i = 0; i < this.Item.length; i++) {
      if (this.Item[i]['id'] == id) {
        return true;
      }
    }
    return false;
  }

  openPanel() {
    this.sps.updateComponentObj(SharingPanelComponent, this.ItemDetail);
  }

  generateActivityReport(learningObj:any) {
    window.open(this.bs.getUserAttr('LMSBaseUrl') + "Control/Controller.aspx?Action=forward/LrnrActvtyRvRprt&CourseLunchId=" + learningObj.CourseID + "&NoPriviledge=1&UserId=" + this.bs.getUserAttr('UserId'), '_blank');
    return false;
  }
  showGamificationRule(id: string) {
    this.Item.push({ 'id': id })
    this.loadGamificationRule(id);
    $('.hideDiv').hide();
    $('#divGamificationRuleforCard' + id).show();
  }

  showReviewPanel(learning:any, type:any) {    
    this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
    let params :any = {
      tab: 'Rating',
      id: learning.CourseID
    }
    if (type == 'P') {
      if (learning['CourseType'] == "T") {
        params['id'] = learning['ILTID'];
        this.bs.routerParam['ILT_DETAIL'] = params;
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), params);
      }
      else {
        this.router.navigate(['/learner/taskList/container/catalog-detail', { tab: 'Rating', id: learning['CourseID'] }], { relativeTo: this.route.parent });
      }
    }
    else {
      if (this.isPlay) {
        if (learning['CourseType'] == 'T') {
          this.router.navigate(['/learner/taskList/container/catalog-ilt-detail', { tab: 'Rating', id: learning['ILTID'], cns: learning['CNS'] }], { relativeTo: this.route.parent });
        }
        else {
          this.router.navigate(['/learner/taskList/container/catalog-detail', { tab: 'Rating', id: learning['CourseID'] }], { relativeTo: this.route.parent });
        }
      } else {
        if (learning['CourseType'] == "T") {
          params['id'] = learning['ILTID'];
          this.bs.routerParam['ILT_DETAIL'] = params;
          /*Navigate to ILT*/
          // this.routeTo(this.bs.getFullPath('ilt_dtl'), params);
          this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), params);
        } else if (learning.CourseType == "E") {
          this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('extrnl_dtls'), params);
        } else {
          /*Navigate to course*/
          params['CourseLaunchId'] = '';
          params['IsNodeClick'] = false;
          // console.log(this.bs.getFullPath('crs_dtl'));
          this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), params);
        }
      }
    }

  }

  ClosePeersPanel(a:any,b:any){return false;}
  ShowPeersPanel(a:any,b:any){return false;}

}
